export const isPlatformOverviewPath = (pathname) =>
	pathname === "/search/admin-dashboard" ||
	pathname === "/aiassistant/admin-dashboard" ||
	pathname.endsWith("/admin-dashboard");
	
export const isAccountSettingsPath = (pathname) =>
	pathname === "/search/settings" || pathname.endsWith("/settings");

export const isUserActivityPath = (pathname) =>
	pathname === "/search/user-activity" || pathname.endsWith("/user-activity");
